export interface PhoneCountry {
  code: string;
  name: string;
  dialCode: string;
  flag: string;
  maxLength: number;
  stripLeadingZero: boolean;
}

const getFlagEmoji = (countryCode: string): string => {
  return countryCode
    .toUpperCase()
    .replace(/./g, char =>
      String.fromCodePoint(127397 + char.charCodeAt(0))
    );
};

const createCountry = (
  code: string,
  name: string,
  dialCode: string,
  maxLength: number,
  stripLeadingZero = true
): PhoneCountry => ({
  code,
  name,
  dialCode,
  flag: getFlagEmoji(code),
  maxLength,
  stripLeadingZero,
});

export const PHONE_COUNTRIES: PhoneCountry[] = [
  createCountry('JP', '日本', '81', 11),
  createCountry('VN', 'ベトナム', '84', 10),
  createCountry('CN', '中国', '86', 11),
  createCountry('KR', '韓国', '82', 11),
  createCountry('US', 'アメリカ', '1', 10, false),
  createCountry('GB', 'イギリス', '44', 10),
  createCountry('DE', 'ドイツ', '49', 11),
  createCountry('FR', 'フランス', '33', 9),
  createCountry('AU', 'オーストラリア', '61', 9),
  createCountry('SG', 'シンガポール', '65', 8, false),
  createCountry('TH', 'タイ', '66', 9),
  createCountry('PH', 'フィリピン', '63', 10),
  createCountry('IN', 'インド', '91', 10),
  createCountry('TW', '台湾', '886', 9),
  createCountry('HK', '香港', '852', 8, false),
  createCountry('MY', 'マレーシア', '60', 10),
  createCountry('ID', 'インドネシア', '62', 11),
  createCountry('CA', 'カナダ', '1', 10, false),
  createCountry('IT', 'イタリア', '39', 10),
  createCountry('ES', 'スペイン', '34', 9),
];

export const DEFAULT_PHONE_COUNTRY_CODE = 'JP';

export const getPhoneCountryByCode = (
  code: string
): PhoneCountry | undefined => {
  return PHONE_COUNTRIES.find(country => country.code === code);
};
